import { grey } from "@mui/material/colors";

import { TemplateContentType } from "features/Influencer/ContactList/schema";

const styles = {
  summary: {
    width: "100%",
    "& .MuiAccordionSummary-content": { width: "100%" },
  },
  summaryText: {
    width: "calc(100% - 50px)",
  },
  checkbox: {
    ml: 0,
  },
  snippet: {
    textOverflow: "ellipsis",
    fontSize: "12px",
    mt: 0.5,
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  buttonTab: {
    border: `1px solid ${grey[300]}`,
    borderBottom: 0,
    borderRadius: 0,
    color: grey[800],
    borderLeft: 0,
    fontSize: { xs: 12, md: 13 },
    textTransform: "none",
    px: 1,
    "&:hover": {
      color: "primary.main",
    },
  },
  container: {
    mt: 6,
    borderBottom: `1px solid ${grey[200]}`,
  },
  scheduledContainer: {
    borderBottom: `1px solid ${grey[200]}`,
  },
  firstBorder: {
    borderTopLeftRadius: 10,
    borderLeft: `1px solid ${grey[200]}`,
  },
  lastBorder: {
    borderTopRightRadius: 10,
  },
  active: {
    backgroundColor: "primary.main",
    color: "white",
  },
  secondaryButton: {
    backgroundColor: "#f0f2ee",
  },

  subjectWrapper: {
    pt: 0.5,
    display: "flex",
    alignItems: "center",
    gap: 1,
    px: 2,
  },
  subjectText: {
    ml: 1,
    width: "100%",
  },
  annotation: {
    fontSize: "12px",
    color: grey[500],
  },
  noBorder: {
    "& .MuiOutlinedInput-root": {
      height: 20,
      "& fieldset": {
        border: "none",
      },
      "&.Mui-focused fieldset": {
        border: "none",
      },
      "&:hover fieldset": {
        border: "none",
      },
    },
    boxShadow: "none",
    ".MuiOutlinedInput-notchedOutline": { border: 0 },
    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
  },
  subjectContainer: {
    borderBottom: `1px solid ${grey[300]}`,
    p: 1,
  },
  toContact: { ml: 2, color: grey[600] },
  templateSelect: {
    ml: -1,
    "& .MuiSelect-select": {
      display: "flex",
      alignItems: "center",
    },
  },
  noSelectBorder: {
    color: "primary.main",
    boxShadow: "none",
    ".MuiOutlinedInput-notchedOutline": { border: 0 },
    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
  },
  templateWidth: {
    maxWidth: { xs: 215, sm: 280, md: "15vw" },
    minWidth: 0,
  },
  templateMenuItem: {
    display: "flex",
    alignItems: "center",
  },
  templateMenuName: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    maxWidth: { xs: 220, sm: 260, md: 500 },
    color: "primary.main",
  },
  editorContainer: (contentType: TemplateContentType) => ({
    overflowY: "scroll",
    maxHeight: contentType === TemplateContentType.OUTREACH ? 350 : 250,
  }),
  scheduledBottomAction: {
    p: 2,
  },
};

export default styles;
